module.exports = "/assets/data/26f30032bd7b1e2372a54e42cbe0b097-SE1.data.json";